import { Group, Modal, Stack, Text } from '@mantine/core';

const SHORTCUTS: [string, string][] = [
  ['/', 'Wyszukiwarka (klient, telefon, adres, numer sprawy)'],
  ['N', 'Nowe zapytanie'],
  ['Ctrl S', 'Zapisz zmiany (oferta, umowa, szablon, uprawnienia roli)'],
  ['Esc', 'Zamknij okno'],
  ['?', 'Ta lista skrótów'],
];

/** Lista skrótów klawiszowych (Shift + ? albo menu użytkownika). Na Macu zamiast Ctrl — Cmd. */
export function ShortcutsModal({ opened, onClose }: { opened: boolean; onClose: () => void }) {
  return (
    <Modal opened={opened} onClose={onClose} title="Skróty klawiszowe" size="md">
      <Stack gap="xs">
        {SHORTCUTS.map(([k, label]) => (
          <Group key={k} justify="space-between" wrap="nowrap" py={4} style={{ borderBottom: '1px solid var(--app-border)' }}>
            <Text size="sm">{label}</Text>
            <span className="kbd-hint" style={{ flexShrink: 0 }}>
              {k}
            </span>
          </Group>
        ))}
        <Text size="xs" c="dimmed">
          Skróty jednoliterowe nie działają podczas pisania w polu tekstowym. Na Macu zamiast Ctrl użyj Cmd.
        </Text>
      </Stack>
    </Modal>
  );
}
